import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@24.19.2_react-dom@19.3.1_react@19.3.1__react@19.3.1/node_modules/next/dist/client/app-dir/link.js");
